import React from "react";
import PageWrapper from "./common.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import ClientDetailTable from "components/report/ClientDetailTable";

const State = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.report"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.client_details_report"
          }
        ]}
      />
      <div className="user-tbl">
        <ClientDetailTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.auth
  };
};

export default connect(mapStateToProps, null)(State);
